import SummaryModule from "../summaryModule/SummaryModule";
import "./UserServicesSummary.scss";

type Props = {
  isInternal: boolean;
  fpConfig: any;
  title: string;
  disableFp?: boolean;
};

export default function UserServicesSummary({
  isInternal,
  fpConfig,
  title,
  disableFp,
}: Props) {
  const getFPLicenseCount = () => {
    if (fpConfig && fpConfig.customerChoice !== "Off") {
      if (isInternal) {
        return fpConfig.userIds.filter((id: string) =>
          id.startsWith("Internal")
        ).length;
      } else {
        return fpConfig.userIds.filter((id: string) =>
          id.startsWith("External")
        ).length;
      }
    }
    return 0;
  };

  return (
    <>
      {!disableFp && (
        <SummaryModule
          moduleTitle={title}
          info="Redigera tillång till tjänster"
        >
          <div className="overflow-sm-auto">
            <table className="table">
            <thead>
              <tr>
                <th>Tjänst i MittKontor</th>
                <th>Licenser för användare</th>
              </tr>
            </thead>
            <tbody>
              {
                <tr>
                  <td>Resultat & Analys</td>
                  <td>{getFPLicenseCount()}</td>
                </tr>
              }
            </tbody>
          </table>
          </div>
        </SummaryModule>
      )}
    </>
  );
}
